import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { PlacementService,AppraisalService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-aproverview',
  templateUrl: './aproverview.component.html',
  styleUrls: ['./aproverview.component.scss'],
  providers:[PlacementService,AppGlobals,AppraisalService]
})
export class AproverviewComponent implements OnInit {

  studentarr:any[];
    depts:any[];
    catgories:any[];
   
    @ViewChild('dt') table: any;
    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    arrcanlst:any=[];
    sections:any=[];
    bloodgp:any=[];
    castecats:any=[];
    subcomb:any=[];
    oprtype:string;
    filtcatgory:any[];
    arhouse:any=[];
    aylist:any[];
    arpayopt:any=[];
    arfeequota:any=[];
    armot:any=[];
    arrcourse:any=[];
    objstudent:any;
    infocnt:any={};
    ttlcnt:any={};
    admdash:any={};
    arrmtongue:any=[];
    objregdata:any={};
    arrstudoctype:any=[];
    arrinst:any=[];
    stuid;
    selnst:any;
    clcd:any;
    arrcansum:any=[]
   
    //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
    tab=1;
    tab1=1;
    selcat:any=0;
    verifiedstatus:any;
    genders:any=[{value:'Male',name:'Male'},{value:'Female',name:'Female'},{value:'Trans',name:'Trans'}];
    statuses:any=[{name:'Enrolled'},{name:'Pending'},{name:'Selected'}];
  
    fileToUpload: File = null;
  
  fData: FormData = new FormData;
  dcid:any=0;
  arrstudoc:any=[];
  disuploadbtn=true;
  status:any="Enrolled";
    //modalOption: NgbModalOptions = {};
    //filteredOptions: Observable<any[]>;
    constructor(private http: HttpClient, private mservice:AppraisalService,private pservice: PlacementService,private modalService: NgbModal,private apglobal:AppGlobals) {
  this.clcd=localStorage.getItem('clcd');
    
     }
  
   
  
   
  
      
  
    ngOnInit(): void {
     
    
    this.getinstitute();
  
    }
   
   
    getinstitute() {
      this.mservice.getinstitute()
          .subscribe(
          resultArray => {
              console.log('getinstitute', resultArray);
              this.arrinst = resultArray;
              this.selnst=resultArray[0].clid;
              this.selaprasses(resultArray[0].clid);
          },
          error => console.log("Error :: " + error)
          )
    }
  
    selaprasses(tag) {
              this.mservice.selaprasses_set(tag)
                  .subscribe(
                  resultArray => {
                      console.log('getdashcounts', resultArray);
                      
                      this.arrcanlst = resultArray;
                     
                      
                  },
                  error => console.log("Error :: " + error)
                  )
            }
        
   printreport(obj,tag){
              debugger;
                var clcd=localStorage.getItem('clcd');
                var aycd=localStorage.getItem('aycd');

                if(tag=='scap')
                {
                  var url=this.mservice.callurl+"fpdf181/pdfreports/aprsl_teacher.php?"+clcd+"&aycd="+aycd+"&ayid="+obj.ayid+"&residh="+obj.residh+"&emid="+obj.emid+"&aprfmid="+obj.aprfmid+"&masclid="+obj.masclid;
                }

                else if(tag=='pgap')
                {
                  var url=this.mservice.callurl+"fpdf181/pdfreports/aprsl_lect.php?"+clcd+"&aycd="+aycd+"&ayid="+obj.ayid+"&residh="+obj.residh+"&emid="+obj.emid+"&aprfmid="+obj.aprfmid+"&masclid="+obj.masclid;
                }
                else if(tag=='pgap3')
                {
                  var url=this.mservice.callurl+"fpdf181/pdfreports/ases_hod.php?"+clcd+"&aycd="+aycd+"&ayid="+obj.ayid+"&residh="+obj.residh+"&emid="+obj.emid+"&aprfmid="+obj.aprfmid+"&masclid="+obj.masclid;
                }
                else if(tag=='strhe')
                {
                  var url=this.mservice.callurl+"fpdf181/pdfreports/aprstrpln_he.php?"+clcd+"&aycd="+aycd+"&ayid="+obj.ayid+"&residh="+obj.residh+"&emid="+obj.emid+"&aprfmid="+obj.aprfmid+"&masclid="+obj.masclid;
                }
  else if(tag=='strsc')
                {
                  var url=this.mservice.callurl+"fpdf181/pdfreports/aprstrpln_sc.php?"+clcd+"&aycd="+aycd+"&ayid="+obj.ayid+"&residh="+obj.residh+"&emid="+obj.emid+"&aprfmid="+obj.aprfmid+"&masclid="+obj.masclid;
                }
                
                else if(tag=='ssap')
                {
                  var url=this.mservice.callurl+"fpdf181/pdfreports/aprsl_sstaf.php?"+clcd+"&aycd="+aycd+"&ayid="+obj.ayid+"&residh="+obj.residh+"&emid="+obj.emid+"&aprfmid="+obj.aprfmid+"&masclid="+obj.masclid;
                }
                //  var url=this.aservice.callurl+"qrcode/2Upevlstubar.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                 window.open(url,'','');
               }
          
    
   exportcandidate(insid){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.pservice.callurl+"export/exppla_candidates.php?clcd="+clcd+"&aycd="+aycd+"&insid="+insid+"&status="+this.status;
  
    // window.open(url,'','_blank');
    window.open(url);
   }
  
   printprofile(insid,stuid){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.pservice.callurl+"qrcode/candidateprofile.php?clcd="+clcd+"&aycd="+aycd+"&insid="+insid+"&stuid="+stuid;
  
    // window.open(url,'','_blank');
    window.open(url);
   }
  }
  
